import React from "react";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { DEV_ASSETS_PATH } from "./Logo.types";
const LOGO_SRC = "commons/logo/v1/logo_dark@2x.png";
const LOGO_HEIGHT = 20;
const LOGO_WIDTH = {
    [Tradename.LOOKIERO]: 102,
    [Tradename.OUTFITTERY]: 164,
};
const Logo = ({ tradename = Tradename.LOOKIERO, assetsPath = DEV_ASSETS_PATH, style: customStyle }) => (React.createElement("img", { alt: "", src: `${assetsPath}/${tradename.toLowerCase()}/${LOGO_SRC}`, style: {
        objectFit: "contain",
        height: LOGO_HEIGHT,
        width: LOGO_WIDTH[tradename],
        display: "block",
        ...customStyle,
    } }));
export { Logo };
